// import './api';
import init from '../../../js/init';

const name = 'parking-map';
const selector = '.parking-map';
const mapSelector = `${selector}__map`;
const tabSelector = `${selector}__tabs .button`;
const tabActiveClass = `button--primary`;
const tabInactiveClass = `button--secondary`;

init(Drupal, name, selector, (root, data) => {
  let map, infowindow;
  let markers = {};
  const tabs = root.querySelectorAll(tabSelector);

  const adjustZoomByScreenSize = () => {
    map.setZoom(window.innerWidth > 1024 ? 15 : 14);
  }

  function initialize() {
    let LatLng = new google.maps.LatLng(data.lat, data.lon);

    map = new google.maps.Map(root.querySelector(mapSelector), {
      zoom: 15,
      scrollwheel: false,
      center: LatLng,
      mapTypeId: google.maps.MapTypeId.STREET,
      styles: [
        {"featureType":"poi","stylers":[{"visibility":"off"}]},
        {"featureType":"administrative","elementType":"geometry","stylers":[{"visibility":"off"}]},
        {"featureType":"administrative.land_parcel","elementType":"geometry","stylers":[{"visibility":"on"}]},
        {"featureType":"administrative.country","elementType":"geometry","stylers":[{"visibility":"on"}]},
        {"featureType":"administrative.province","elementType":"geometry","stylers":[{"visibility":"on"}]},
        {"featureType":"administrative.neighborhood","elementType":"geometry","stylers":[{"visibility":"on"}]},
        {"featureType":"administrative.locality","elementType":"geometry","stylers":[{"visibility":"on"}]},
        {"featureType":"administrative.locality","elementType":"labels","stylers":[{"hue":"#548096"},{"saturation":-50},{"lightness":35},{"visibility":"on"}]},
        {"featureType":"road","elementType":"labels","stylers":[{"visibility":"simplified"}]},
        {"featureType":"water","elementType":"geometry","stylers":[{"hue":"#548096"},{"saturation":-37},{"lightness":-10},{"visibility":"on"}]},
        {"featureType":"landscape","elementType":"all","stylers":[{"hue":"#E3CBAC"},{"saturation":31},{"lightness":-12},{"visibility":"on"}]},
        {"featureType":"road","stylers":[{"visibility":"simplified"},{"saturation":-49},{"lightness":5}]},
        {"featureType":"road","elementType":"geometry","stylers":[{"visibility":"simplified"},{"saturation":-90},{"lightness":90}]},
        {"featureType":"administrative.land_parcel","stylers":[{"visibility":"off"},{"lightness":25}]}
      ]
    });

    let locations = data.locations;

    infowindow = new google.maps.InfoWindow();

    for (let i = 0; i < locations.length; i++) {
      locations[i][0] = parseFloat(locations[i][0]);
      locations[i][1] = parseFloat(locations[i][1]);

      // Standard marker
      let icon = {
        url: locations[i][3],
        scaledSize: new google.maps.Size(19, 19),
        anchor: new google.maps.Point(10, 19),
      };

      let position = new google.maps.LatLng(locations[i][0], locations[i][1]);

      let marker = new google.maps.Marker({
        map: map,
        position: position,
        icon: icon,
        infowindow: locations[i][7],
      });

      google.maps.event.addListener(marker, 'click', (function (_, i) {
        return function () {
          activateMarker(locations[i][2]);
        }
      })(marker, i));

      if (locations[i][5].length) {
        let coords = locations[i][5];
        let shape = new google.maps.Polygon({
          path: coords,
          geodesic: true,
          strokeColor: '#003594',
          fillColor: '#003594',
          fillOpacity: 0.35,
          strokeOpacity: 0.9,
          strokeWeight: 2,
          map: map,
        });

        google.maps.event.addListener(shape, "click", (function (marker, i) {
          return function () {
            activateMarker(locations[i][2]);
          }
        })(marker, i));
      }

      markers[locations[i][2]] = marker;
    }

    google.maps.event.addListener(infowindow, 'closeclick', function(){
      activateMarker('all');
    });
    adjustZoomByScreenSize();
    window.addEventListener("resize", adjustZoomByScreenSize);
  }

  initialize(); // initialize gmap

  tabs.forEach(tab => {
    const id = tab.getAttribute('data-id');
    tab.onclick = () => activateMarker(id);
  });

  function activateMarker(id) {
    if (id == 'all') {
      map.setZoom(14);
      map.panTo(new google.maps.LatLng(data.lat, data.lon));

      tabs.forEach(tab => {
        const tabId = tab.getAttribute('data-id');

        tab.classList.toggle(tabActiveClass, tabId === 'all');
        tab.classList.toggle(tabInactiveClass, tabId !== 'all');
      });

      infowindow.close();
    } else {
      map.setZoom(16);
      map.panTo(markers[id].getPosition());
      infowindow.setContent(markers[id].infowindow);
      infowindow.open(map, markers[id]);

      tabs.forEach(tab => {
        const tabId = tab.getAttribute('data-id');

        tab.classList.toggle(tabActiveClass, tabId === id);
        tab.classList.toggle(tabInactiveClass, tabId !== id);
      });
    }
  }
});
